import React from 'react';
import { RenderEditable, RenderElement } from 'components/RenderHelpers';
import { CanUserEditContact } from 'appconstants/Permission';
import { compose, withHandlers, withState } from 'recompose';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum } from 'appconstants';
import { bindLogger } from 'helpers/BindLogger';
import { withAppContext } from '@ctsu/loader';
import { GetFromCtxValue } from 'helpers';
import { setProtocolContact } from 'actions/protocols/protocoldetail';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import EditContact from './EditContact';
import ViewContact from './ViewContact';

const Contact = ({
  contact, state, toggleContact, onSaveContact
}) => (
  <RenderEditable
    state={state}
    editable={CanUserEditContact()}
    setState={toggleContact}
    title="Contact"
  >
    <RenderElement access={state === true}>
      <EditContact
        contact={contact}
        onSaveContact={onSaveContact}
        closeContact={toggleContact}
        type="Contact"
      />
    </RenderElement>
    <RenderElement access={state === false}>
      <ViewContact
        data={contact || {}}
        toggleContact={toggleContact}
      />
    </RenderElement>
  </RenderEditable>
);

Contact.propTypes = {
  contact: PropTypes.oneOfType([PropTypes.object]),
  toggleContact: PropTypes.func,
  onSaveContact: PropTypes.func
};

Contact.defaultProps = {
  contact: null,
  toggleContact: null,
  onSaveContact: null
};

const withConnectState = connect(
  (state, ownProps) => ({}),
  dispatch => bindActionCreators(
    {
      onSetProtocolContact: setProtocolContact
    },
    dispatch
  )
);


export default compose(
  withConnectState,
  withAppContext,
  withState('state', 'setState', false),
  withHandlers({
    toggleContact: props => event => {
      const { setState, state } = props;
      setState(!state);
    }
  }),
  withHandlers({
    onSaveContact: props => (contact, type) => {
      const {
        context,
        toggleContact,
        prtId,
        onSetProtocolContact
      } = props;
      bindLogger(onSetProtocolContact, context)(
        contact,
        prtId
      ).subscribe(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          openSnackbar({
            message: GetFromCtxValue(context, 'PROTOCOL_CONTACT_SUCCESS'),
            variant: 'success',
            name: 'contact'
          });
          toggleContact();
        }
      });
    }
  })
)(Contact);
